export default async(modul_id,actualRoom,settings) =>
{
    console.log('%c 👤 Registration Module Loaded! ', 'background: #222; color: #bada55');
}
